import * as client_hooks from '../../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65')
];

export const server_loads = [0,6,13,2,8,9,10];

export const dictionary = {
		"/(vendor)/corporations/[corpId=uuid]": [62,[6,13],[7]],
		"/(vendor)/shared-workspace-setup/[setupId=uuid]": [63,[6],[7]],
		"/(consumer)/s/[suiteId=uuid]/[entryKey]/[entrypointId=uuid]": [~15,[2,4],[3]],
		"/(consumer)/s/[suiteId=uuid]/[entryKey]/[entrypointId=uuid]/interstitial": [~16,[2,4],[3]],
		"/(consumer)/s/[...path]": [14,[2,4],[3]],
		"/(vendor)/trial-expired": [64,[6],[7]],
		"/(consumer)/v/domain": [22,[2,5],[3]],
		"/(consumer)/v/[suiteId=uuid]/[entryKey]/[entrypointId=uuid]": [~18,[2,5],[3]],
		"/(consumer)/v/[suiteId=uuid]/[entryKey]/[entrypointId=uuid]/interstitial": [~21,[2,5],[3]],
		"/(consumer)/v/[suiteId=uuid]/[entryKey]/[entrypointId=uuid]/[destKey]": [~19,[2,5],[3]],
		"/(consumer)/v/[suiteId=uuid]/[entryKey]/[entrypointId=uuid]/[destKey]/interstitial": [~20,[2,5],[3]],
		"/(consumer)/v/[...path]": [17,[2,5],[3]],
		"/(vendor)/workspaces": [65,[6],[7]],
		"/(vendor)/[orgId=uuid]/admin/billing": [27,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/brands": [28,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/brands/[id=uuid]": [~29,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/contacts/[id]": [31,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/dashboards": [32,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/dashboards/classic": [34,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/settings": [35,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/teams": [36,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/users": [38,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/users/[userId=uuid]/workspaces": [39,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/workspaces": [40,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/welcome": [~42,[6,8],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/admin": [44,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/analytics": [45,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/audiences": [46,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/brands": [47,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/brands/[id=uuid]": [~48,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/builder": [49,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/calendar": [50,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/contacts": [51,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/contacts/[id]": [52,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/conversions/[id=uuid]": [~53,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/conversions/[id=uuid]/edit": [~54,[6],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/conversions/[id=uuid]/polls/[id=uuid]": [~56,[11],[12]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/conversions/[id=uuid]/polls/[...path]": [55,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/dashboards": [57,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/dashboards/classic": [59,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/dashboards/[id]": [58,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/home": [60,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/search": [61,[6,8,10],[7]],
		"/(vendor)/[orgId=uuid]/workspaces/[workspaceId=uuid]/[...folder]/conversions": [43,[6,8,10],[7]],
		"/(vendor)/[...path]/access-denied": [24,[6],[7]],
		"/(vendor)/[orgId=uuid]/admin": [25,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/activity": [26,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/contacts": [30,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/dashboards/[id]": [33,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/teams/[teamId=uuid]": [37,[6,8,9],[7]],
		"/(vendor)/[orgId=uuid]/admin/workspaces/[workspaceId=uuid]": [41,[6,8,9],[7]],
		"/(vendor)/[...path]": [23,[6],[7]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);